/**
 * InviteSuccessState Component
 * Shared success confirmation displayed after invite-style account creation.
 * Defaults match the Care-Seeker copy + redirect so existing call sites are unchanged.
 */

import { Link } from 'react-router-dom';
import { InviteSignupShell } from './InviteSignupShell';

export type InviteSuccessStateProps = {
  email?: string;
  headline?: string;
  subtext?: string;
  redirectUrl?: string;
};

export const InviteSuccessState = ({
  email,
  headline = 'Account Created!',
  subtext = "You'll receive an email to set up your password.",
  redirectUrl,
}: InviteSuccessStateProps) => {
  const loginUrl =
    redirectUrl ??
    `/?email=${encodeURIComponent(email ?? '')}&autoLogin=true`;

  return (
    <InviteSignupShell>
      <div className="mb-8 rounded-3xl bg-white/15 p-8 text-center">
        <div className="text-5xl mb-4">✅</div>
        <h2 className="font-recoleta text-white text-3xl md:text-4xl mb-4">
          {headline}
        </h2>
        <p className="font-termina text-white mb-2">
          Your account has been created successfully.
        </p>
        <p className="font-termina text-white/80">{subtext}</p>
      </div>

      <p className="font-termina text-white text-center">
        Redirecting you to sign in...
      </p>

      <div className="text-center mt-6">
        <Link
          to={loginUrl}
          className="font-termina text-white underline hover:font-bold"
        >
          Click here if not redirected
        </Link>
      </div>
    </InviteSignupShell>
  );
};
